import { createApiRef } from '@backstage/core-plugin-api';

export const vwtechLibsApiRef = createApiRef<VwtechLibsApi>({
  id: 'plugin.vwtech-libs.service',
});

export interface VwtechLibsApi {
  /**
   * Download a package containing all custom Draw.io libraries.
   * The optional filename parameter is ignored by the implementation and
   * kept only for backward compatibility with existing UI calls.
   */
  getLibrariesFile(filename?: string): Promise<Blob>;

  /**
   * Download the official IT Architecture Landscape Draw.io file.
   */
  getLandscapeFile(): Promise<{ blob: Blob; filename: string }>;
} 